import { render, staticRenderFns } from "./Caja.vue?vue&type=template&id=7cc21146&"
import script from "./Caja.vue?vue&type=script&lang=js&"
export * from "./Caja.vue?vue&type=script&lang=js&"
import style0 from "./Caja.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports